import { useState, useEffect, useCallback } from 'react'
import { appsyncQuery } from '@api/appsync-client'

const GET_ADMIN_OVERVIEW = `
  query GetAdminOverview($period: String) {
    getAdminOverview(period: $period) {
      period activeUsers totalUsers activeUsersDelta prepRate prepRateDelta
      sessionsCreated sessionsCompleted avgCardsPerSession mostUsedCard
    }
  }
`

const GET_ADMIN_ALERTS = `
  query GetAdminAlerts {
    getAdminAlerts {
      type severity count message
    }
  }
`

export function useAdminOverview(period = '30d') {
  const [overview, setOverview] = useState(null)
  const [alerts, setAlerts] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      const [ov, al] = await Promise.all([
        appsyncQuery(GET_ADMIN_OVERVIEW, { period }).then((d) => d.getAdminOverview),
        appsyncQuery(GET_ADMIN_ALERTS).then((d) => d.getAdminAlerts),
      ])
      setOverview(ov)
      setAlerts(al || [])
    } catch (err) {
      setError(err)
    } finally {
      setLoading(false)
    }
  }, [period])

  useEffect(() => { load() }, [load])

  return { overview, alerts, loading, error, reload: load }
}
